import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const DeleteIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="DeleteIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/delete">
            <path
                d="M14.7872 9.00546L14.4352 18.236M9.56498 18.236L9.21304 9.00546M15.8145 5.30607C16.9983 5.39847 18.1783 5.53429 19.3522 5.71324C19.7001 5.76657 20.046 5.82298 20.3918 5.88349M19.3522 5.71324L18.2659 19.9518C18.2216 20.5315 17.9618 21.073 17.5386 21.4679C17.1154 21.8629 16.56 22.0822 15.9834 22.082H8.01684C7.4402 22.0822 6.88474 21.8629 6.46155 21.4679C6.03837 21.073 5.77863 20.5315 5.7343 19.9518L4.64795 5.71324M4.64795 5.71324C4.30008 5.76554 3.95424 5.82195 3.6084 5.88246M4.64795 5.71324C5.82191 5.53429 7.00193 5.39848 8.18569 5.30607M15.8145 5.30607V4.36661C15.8145 3.15638 14.8889 2.14718 13.6886 2.10923C12.5632 2.07296 11.437 2.07296 10.3116 2.10923C9.11132 2.14718 8.18569 3.15741 8.18569 4.36661V5.30607M15.8145 5.30607C13.2754 5.10821 10.7248 5.10821 8.18569 5.30607"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </SvgIcon>
)
